"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1489],{

/***/ 9451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fb": function() { return /* binding */ Head; },
/* harmony export */   "Nk": function() { return /* binding */ BodyMask; }
/* harmony export */ });
/* unused harmony export Body */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var Item = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__Item", componentId: "sc-1lvw3w1-0" })(["width:100%;"]);



var Head = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__Head", componentId: "sc-1lvw3w1-1" })(["cursor:pointer;"]);



var Body = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__Body", componentId: "sc-1lvw3w1-2" })(["height:0;overflow:hidden;transition:height 0.5s ease-in-out;"]);





var BodyMask = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({ displayName: "Accordion__BodyMask", componentId: "sc-1lvw3w1-3" })(["padding:0;margin:0;"]);













var Accordion = function Accordion(props) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var _props$isOpen = props.isOpen,isOpen = _props$isOpen === void 0 ? false : _props$isOpen;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen),open = _useState[0],setOpen = _useState[1];

  var updateBodyHeight = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var el = ref.current;
    if (el) {
      // for some reason open is not upto date state which causes a close
      setOpen(function (open) {
        var bodyEl = el.querySelector(Body.toString());
        if (!open) {
          // we close
          bodyEl.style.height = '0px';
        } else {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              var height = bodyEl.
              querySelector(BodyMask.toString()).
              getBoundingClientRect().height;
              // we open
              bodyEl.style.height = "".concat(height, "px");
            });
          });
        }

        return open;
      });
    }
  }, [ref.current, open]);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var el = ref.current;
    if (el) {
      var body = el.querySelector(Body.toString());
      var observer = new MutationObserver(function () {
        updateBodyHeight();
      });

      var config = { childList: true, subtree: true };

      observer.observe(body, config);

      return function () {
        observer.disconnect();
        observer = null;
      };
    }
  }, []);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    updateBodyHeight();
  }, [open]);

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (open !== isOpen) {
      setOpen(isOpen);
    }
  }, [isOpen]);

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Item, { ref: ref, className: props.className, children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Head, {

        onClick: function onClick() {
          if (typeof props.handleOpen === 'function') {
            props.handleOpen();
          } else {var _props$onOpenChange;
            setOpen(!open);
            props === null || props === void 0 ? void 0 : (_props$onOpenChange = props.onOpenChange) === null || _props$onOpenChange === void 0 ? void 0 : _props$onOpenChange.call(props, !open);
          }
        }, children:

        props.head }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Body, { children: /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BodyMask, { children: props.body }) })] }));



};

/* harmony default export */ __webpack_exports__["ZP"] = (Accordion);

/***/ }),

/***/ 82772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _components_form_Input2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45330);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({ displayName: "Search__Wrapper", componentId: "sc-zz0z24-0" })(["position:relative;width:100%;border-bottom:1px solid #D8D8D8;margin-top:20px;margin-bottom:20px;"]);







var SearchIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({ displayName: "Search__SearchIcon", componentId: "sc-zz0z24-1" })(["position:absolute;top:calc(50% - 8px);height:20px;"]);





var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_components_form_Input2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({ displayName: "Search__Input", componentId: "sc-zz0z24-2" })(["color:#242424;line-height:1;border:none;padding:14px 24px 14px 30px;input:focus{background:none;}::placeholder{color:#242424;}"]);














var Search = function Search(_ref) {var handleChange = _ref.handleChange,placeholder = _ref.placeholder,_ref$value = _ref.value,value = _ref$value === void 0 ? '' : _ref$value;
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Wrapper, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SearchIcon, { name: "ygb-icon-searchb", fontSize: "18px", color: "#000" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Input, {
        name: "search",
        placeholder: placeholder,
        onChange: function onChange(e) {return handleChange(e.target.value);},
        value: value })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (Search);

/***/ }),

/***/ 70467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85169);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94007);
/* harmony import */ var _organisms_SimpleAccordionList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2949);
/* harmony import */ var _components_SectionHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70300);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var FAQContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_0__/* .Container */ .W2).withConfig({ displayName: "FAQSection__FAQContainer", componentId: "sc-1y8plnv-0" })(["padding-left:20px;padding-right:20px;box-sizing:border-box;.SectionHeader--H2SectionHeader{font-size:18px;font-weight:500;}"]);










var FAQWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu).withConfig({ displayName: "FAQSection__FAQWrapper", componentId: "sc-1y8plnv-1" })(["max-width:1024px;margin:0 auto;"]);




var FAQ = [
{
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item1.title" }),
  body: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item1.body" }) },

{
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item2.title" }),
  body: /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, {
    id: "programs_listing.faq.item2.body",
    components: [/*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {

      href: "https://yogobe.com/se/me/dashboard",
      target: "_blank",
      rel: "noreferrer" }, "0")] }) },





{
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item3.title" }),
  body: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item3.body" }) },

{
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item4.title" }),
  body: /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, { children: [/*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item4.body" }), /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("br", {}), /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("br", {}), /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item4.body2" })] }) },



{
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item5.title" }),
  body: /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, {
    id: "programs_listing.faq.item5.body",
    components: [/*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {

      href: "mailto:business@yogobe.com",
      target: "_blank",
      rel: "noreferrer" }, "0")] }) },





{
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item6.title" }),
  body: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item6.body" }) },

{
  title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "programs_listing.faq.item7.title" }),
  body: /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, {
    id: "programs_listing.faq.item7.body",
    components: [/*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {

      href: "https://yogobe.com/se/register/account",
      target: "_blank",
      rel: "noreferrer" }, "0"), /*#__PURE__*/

    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {

      href: "https://yogobe.com/se/blog/wellnet-actiway-benify-friskvardsbidrag",
      target: "_blank",
      rel: "noreferrer" }, "1"), /*#__PURE__*/

    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {

      href: "https://yogobe.com/se/me/settings/subscriptions",
      target: "_blank",
      rel: "noreferrer" }, "2")] }) }];







var FAQSection = function FAQSection(_ref) {var _ref$faq = _ref.faq,faq = _ref$faq === void 0 ? FAQ : _ref$faq;
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(FAQContainer, { id: "faq", flexDirection: "column", mt: [-20, 0, 0], py: 40, children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(FAQWrapper, { mb: [25], mx: "auto", children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_SectionHeader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_5__/* .Trans */ .cC, { id: "metadata.frequently_asked_questions.title" }) }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_organisms_SimpleAccordionList__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { list: faq })] }) }));



};

/* harmony default export */ __webpack_exports__["Z"] = (FAQSection);

/***/ }),

/***/ 72738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ ProgramsSearch; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@lingui/core/esm/index.js + 1 modules
var esm = __webpack_require__(94471);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var react_esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./components/EmptyResults.tsx
var EmptyResults = __webpack_require__(87977);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./ecosystems/events/Search.tsx
var Search = __webpack_require__(82772);
// EXTERNAL MODULE: ./components/Spinner.tsx
var Spinner = __webpack_require__(24452);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
// EXTERNAL MODULE: ./lib/apollo/policies/index.ts + 23 modules
var policies = __webpack_require__(54734);
// EXTERNAL MODULE: ./lib/contexts/UserProvider.tsx
var UserProvider = __webpack_require__(47493);
// EXTERNAL MODULE: ./organisms/cards/ProgramListingCard/index.tsx
var ProgramListingCard = __webpack_require__(80226);
// EXTERNAL MODULE: ./pages/[lang]/programs/index.tsx
var _lang_programs = __webpack_require__(15783);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(12922);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
// EXTERNAL MODULE: ./components/form/Select.tsx
var Select = __webpack_require__(76611);
// EXTERNAL MODULE: ./organisms/Languages.tsx
var Languages = __webpack_require__(38198);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(54444);
// EXTERNAL MODULE: ./organisms/modals/base/index.tsx + 3 modules
var base = __webpack_require__(10842);
// EXTERNAL MODULE: ./lib/constants.tsx
var constants = __webpack_require__(22498);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./ecosystems/programs_listing/ProgramsFilters.tsx
var _templateObject, _templateObject2, _OPTIONS;













var Filters = styled_components_browser_esm["default"].div.withConfig({ displayName: "ProgramsFilters__Filters", componentId: "sc-1y3p8w0-0" })(["position:sticky;top:0;padding:10px 20px;background-color:#F0F5FB;box-shadow:2px 2px 4px #09080838;z-index:9;"]);








var ProgramsFilters_Select = (0,styled_components_browser_esm["default"])(Select/* default */.Z).withConfig({ displayName: "ProgramsFilters__Select", componentId: "sc-1y3p8w0-1" })(["background-color:", ";.MuiInputBase-root{.MuiSelect-select{font-size:13px;text-transform:capitalize;border:solid 1px #dddddd;border-radius:5px;padding:10px 35px 10px 14px;}.MuiSelect-icon{right:5px;}}"],
function (_ref) {var theme = _ref.theme;return theme.colors.neutrals.white;});

















var MobileFilterOpen = styled_components_browser_esm["default"].button.withConfig({ displayName: "ProgramsFilters__MobileFilterOpen", componentId: "sc-1y3p8w0-2" })(["border:1px solid lightgrey;border-radius:3px;padding:12px 20px;margin:0 auto;background-color:white;"]);







var PROGRAM_INSTRUCTORS_QUERY = (0,lib/* gql */.Ps)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query programInstructors($option: Option = program_instructors_only) {\n    instructors(perPage: 100, page: 1, option: $option) {\n      data {\n        name\n        slug\n      }\n    }\n  }\n"])));










var PROGRAM_THEMES_QUERY = (0,lib/* gql */.Ps)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  query programThemes($category: ProgramCategory = programs) {\n    programThemes(category: $category)\n  }\n"])));





var sortOptions = [
{
  label: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "programs_2021.listings_page.filters.sort_by" }),
  value: '-1' },

{
  label: /*#__PURE__*/
  (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "programs_2021.listings_page.filters.sort_alphabetically" }),

  value: 'alphabetical' },

{
  label: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "programs_2021.listings_page.filters.sort_duration" }),
  value: 'duration' },

{
  label: /*#__PURE__*/(0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "programs_2021.listings_page.filters.sort_new" }),
  value: 'newest_first' }];



var OPTIONS = (_OPTIONS = {}, (0,defineProperty/* default */.Z)(_OPTIONS,
generated/* ProgramCategory.Programs */.l92.Programs, generated/* Option.ProgramInstructorsOnly */.Wxm.ProgramInstructorsOnly), (0,defineProperty/* default */.Z)(_OPTIONS,
generated/* ProgramCategory.Courses */.l92.Courses, generated/* Option.CourseInstructorsOnly */.Wxm.CourseInstructorsOnly), (0,defineProperty/* default */.Z)(_OPTIONS,
generated/* ProgramCategory.Healthcare */.l92.Healthcare, 'healthcare_instructors_only'), _OPTIONS);


var FilterInputs = function FilterInputs(_ref2)










{var isMobile = _ref2.isMobile,_ref2$languages = _ref2.languages,languages = _ref2$languages === void 0 ? ['se', 'en', 'no', 'fi'] : _ref2$languages,instructor = _ref2.instructor,sortBy = _ref2.sortBy,theme = _ref2.theme,programCategory = _ref2.programCategory,onLanguageChange = _ref2.onLanguageChange,onInstructorChange = _ref2.onInstructorChange,onSortChange = _ref2.onSortChange,onThemeChange = _ref2.onThemeChange;
  var _useQuery = (0,useQuery/* useQuery */.a)(

  PROGRAM_INSTRUCTORS_QUERY, {
    variables: { option: OPTIONS[programCategory] } }),instructorsData = _useQuery.data,instructorsError = _useQuery.error;

  //
  var _useQuery2 = (0,useQuery/* useQuery */.a)(

  PROGRAM_THEMES_QUERY, { variables: { category: programCategory } }),ThemesData = _useQuery2.data;

  var mt = isMobile ? 20 : 0;
  var direction = isMobile ? 'column' : 'row';

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
      (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, { flexDirection: direction, children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 10, mt: mt, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(ProgramsFilters_Select, {
            name: "sort",
            options: sortOptions,
            valueKey: "value",
            displayTextKey: "label",
            selectedValue: sortBy === null ? '-1' : sortBy,
            onChange: function onChange(e) {
              var value = e.target.value;
              onSortChange(value === '-1' ? null : value);
            } }) }),


        !instructorsError ? /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 10, mt: mt, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(ProgramsFilters_Select, {
            name: "instructors",
            options: [
            {
              label: /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "programs_2021.listings_page.filters.instructors" }),

              value: '-1' }].concat((0,toConsumableArray/* default */.Z)(

            ((instructorsData === null || instructorsData === void 0 ? void 0 : instructorsData.instructors.data) || []).map(
            function (instructor) {return {
                label: instructor.name,
                value: instructor.slug };}))),



            valueKey: "value",
            displayTextKey: "label",
            selectedValue: instructor === null ? '-1' : instructor,
            onChange: function onChange(e) {
              var instructor = e.target.value;
              onInstructorChange(instructor === '-1' ? null : instructor);
            } }) }) :


        null, /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mr: 10, mt: mt, children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(ProgramsFilters_Select, {
            name: "theme",
            options: [
            {
              label: /*#__PURE__*/
              (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "programs_2021.listings_page.filters.kind_theme" }),

              value: '-1' }].concat((0,toConsumableArray/* default */.Z)(

            ((ThemesData === null || ThemesData === void 0 ? void 0 : ThemesData.programThemes) || []).map(function (theme) {return {
                label: esm/* i18n._ */.ag._( /*i18n*/{ id: constants/* PROGRAM_THEMES */.oM[theme] }),
                value: theme };}))),


            valueKey: "value",
            displayTextKey: "label",
            selectedValue: theme === null ? '-1' : theme,
            onChange: function onChange(e) {
              var value = e.target.value;
              onThemeChange(value === '-1' ? null : value);
            } }) })] }), /*#__PURE__*/



      (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, {
        mt: mt,
        flex: 1,
        justifyContent: isMobile ? 'center' : 'flex-end',
        alignItems: "center", children: [/*#__PURE__*/

        (0,jsx_runtime.jsxs)("span", { children: [
          programCategory === generated/* ProgramCategory.Courses */.l92.Courses ? /*#__PURE__*/
          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "courses_2021.listings_page.filters.languages" }) : /*#__PURE__*/

          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "programs_2021.listings_page.filters.languages" }), ":"] }), /*#__PURE__*/



        (0,jsx_runtime.jsx)(Languages/* default */.Z, {
          languages: languages,
          onChange: onLanguageChange,
          enabledLanguages: ['se', 'en', 'no', 'fi'] })] })] }));




};

var FilterModal = function FilterModal(_ref3)










{var languages = _ref3.languages,instructor = _ref3.instructor,sortBy = _ref3.sortBy,theme = _ref3.theme,programCategory = _ref3.programCategory,onLanguageChange = _ref3.onLanguageChange,onInstructorChange = _ref3.onInstructorChange,onSortChange = _ref3.onSortChange,onThemeChange = _ref3.onThemeChange,onClose = _ref3.onClose;
  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)(base/* Modal */.u_, { open: true, children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(base/* Header */.h4, { handleClose: onClose, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.filters.sort_modal_title" }) }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(base/* Body */.uT, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { flexDirection: "column-reverse", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(FilterInputs, {
            languages: languages,
            instructor: instructor,
            sortBy: sortBy,
            theme: theme,
            onInstructorChange: onInstructorChange,
            onLanguageChange: onLanguageChange,
            onSortChange: onSortChange,
            onThemeChange: onThemeChange,
            programCategory: programCategory,
            isMobile: true }) }) })] }));





};

var ProgramsFilters = function ProgramsFilters(_ref4)










{var _ref4$className = _ref4.className,className = _ref4$className === void 0 ? '' : _ref4$className,languages = _ref4.languages,instructor = _ref4.instructor,sortBy = _ref4.sortBy,theme = _ref4.theme,onLanguageChange = _ref4.onLanguageChange,onInstructorChange = _ref4.onInstructorChange,onSortChange = _ref4.onSortChange,onThemeChange = _ref4.onThemeChange,_ref4$programCategory = _ref4.programCategory,programCategory = _ref4$programCategory === void 0 ? generated/* ProgramCategory.Programs */.l92.Programs : _ref4$programCategory;
  var CSStheme = (0,react.useContext)(styled_components_browser_esm.ThemeContext);
  var _useState = (0,react.useState)(false),isModalOpen = _useState[0],openModal = _useState[1];

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Filters, { className: className, children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(Grid/* Container */.W2, { flexWrap: "wrap", children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_media/* default */.Z, { query: "(min-width: ".concat(CSStheme.viewports.tablet, "px)"), children:
          function children(matches) {
            if (matches) {
              return /*#__PURE__*/(
                (0,jsx_runtime.jsx)(FilterInputs, {
                  languages: languages,
                  instructor: instructor,
                  sortBy: sortBy,
                  theme: theme,
                  onInstructorChange: onInstructorChange,
                  onLanguageChange: onLanguageChange,
                  onSortChange: onSortChange,
                  onThemeChange: onThemeChange,
                  programCategory: programCategory,
                  isMobile: false }));


            } else {
              return /*#__PURE__*/(
                (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, { children: [/*#__PURE__*/
                  (0,jsx_runtime.jsxs)(MobileFilterOpen, {
                    onClick: function onClick() {
                      openModal(true);
                    }, children: [/*#__PURE__*/

                    (0,jsx_runtime.jsx)(Icon/* default */.Z, { name: "ygb-icon-restart" }), ' ', /*#__PURE__*/
                    (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "live.listings_page.filters.sort_mobile_label" })] }),

                  isModalOpen ? /*#__PURE__*/
                  (0,jsx_runtime.jsx)(FilterModal, {
                    languages: languages,
                    instructor: instructor,
                    sortBy: sortBy,
                    theme: theme,
                    onInstructorChange: onInstructorChange,
                    onLanguageChange: onLanguageChange,
                    onSortChange: onSortChange,
                    onThemeChange: onThemeChange,
                    programCategory: programCategory,
                    onClose: function onClose() {return openModal(false);} }) :

                  null] }));


            }
          } }) }) }));




};

/* harmony default export */ var programs_listing_ProgramsFilters = (ProgramsFilters);
// EXTERNAL MODULE: ./lib/helpers.ts
var helpers = __webpack_require__(32460);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(1644);
;// CONCATENATED MODULE: ./ecosystems/programs_listing/ProgramsSearch.tsx
function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}



















var Cards = styled_components_browser_esm["default"].div.withConfig({ displayName: "ProgramsSearch__Cards", componentId: "sc-1887831-0" })(["display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,400px));justify-content:center;grid-gap:20px;@media (min-width:", "px){grid-template-columns:repeat(2,1fr);grid-gap:30px;}@media (min-width:", "px){grid-template-columns:repeat(auto-fill,minmax(300px,1fr));grid-gap:40px;}"],





function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;},




function (_ref2) {var theme = _ref2.theme;return theme.viewports.laptop;});





var LoadMore = (0,styled_components_browser_esm["default"])(buttons/* default */.ZP).withConfig({ displayName: "ProgramsSearch__LoadMore", componentId: "sc-1887831-1" })(["--color:", ";--border-color:", ";color:var(--color);border:1px solid var(--border-color);border-radius:3px;padding:12px 24px;background:none;:hover{color:var(--color);border:1px solid var(--border-color);opacity:0.8;}"],
function (_ref3) {var category = _ref3.category,theme = _ref3.theme;return (
    category === generated/* ProgramCategory.Courses */.l92.Courses ?
    theme.colors.primary.green :
    '#242424');},
function (_ref4) {var category = _ref4.category,theme = _ref4.theme;return (
    category === generated/* ProgramCategory.Courses */.l92.Courses ?
    theme.colors.primary.green :
    '#979797');});














var ProgramsSearch = function ProgramsSearch(_ref5)



{var ssrData = _ref5.ssrData,initialFilters = _ref5.initialFilters,_ref5$programCategory = _ref5.programCategory,programCategory = _ref5$programCategory === void 0 ? generated/* ProgramCategory.Programs */.l92.Programs : _ref5$programCategory;
  var router = (0,next_router.useRouter)();
  var query = router.query;
  var lang = query === null || query === void 0 ? void 0 : query.lang;
  var _useState = (0,react.useState)((0,_lang_programs.buildProgramsFilters)(query)),filters = _useState[0],setFilters = _useState[1];
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0];
  var _useGenericProgramsQu =





  (0,generated/* useGenericProgramsQuery */.$sk)({
    notifyOnNetworkStatusChange: true,
    variables: _objectSpread({
      page: 1,
      perPage: 12 },
    initialFilters || {}),

    ssr: false }),data = _useGenericProgramsQu.data,loading = _useGenericProgramsQu.loading,fetchMore = _useGenericProgramsQu.fetchMore,refetch = _useGenericProgramsQu.refetch,networkStatus = _useGenericProgramsQu.networkStatus;


  var firstRender = (0,react.useRef)(true);
  var _useRef = (0,react.useRef)(
  debounce_default()(
  function (_ref6) {var search = _ref6.search,languages = _ref6.languages,instructor = _ref6.instructor,sortBy = _ref6.sortBy,theme = _ref6.theme;
    refetch({
      page: 1,
      category: programCategory,
      search: search === '' ? '*' : search,
      languages: languages,
      instructor: instructor,
      sortBy: sortBy,
      theme: theme });

  },
  500,
  {
    maxWait: 3000,
    leading: false,
    trailing: true })),searchRef = _useRef.current;




  (0,react.useEffect)(function () {
    refetch();
  }, [lang]);

  (0,react.useEffect)(function () {
    if (!firstRender.current) {
      searchRef({
        category: programCategory,
        search: filters.search,
        languages: filters.languages,
        instructor: filters.instructor,
        sortBy: filters.sortBy,
        theme: filters.theme });

    } else {
      firstRender.current = false;
    }
  }, [
  filters.search,
  filters.languages,
  filters.instructor,
  filters.theme,
  filters.sortBy]);


  var loadMore = function loadMore() {var _data$genericPrograms;
    fetchMore({
      variables: _objectSpread(_objectSpread({
        page: (data === null || data === void 0 ? void 0 : (_data$genericPrograms = data.genericPrograms) === null || _data$genericPrograms === void 0 ? void 0 : _data$genericPrograms.page) + 1,
        perPage: 12 },
      filters), {}, {
        category: programCategory,
        search: filters.search === '' ? '*' : filters.search }) });


  };

  var clearFilters = function clearFilters() {
    setFilters({
      search: '',
      category: programCategory,
      languages: [generated/* LanguageKind.En */.$PN.En, generated/* LanguageKind.Se */.$PN.Se],
      instructor: null,
      sortBy: generated/* GenericProgramSortAttribute.NewestFirst */.N$9.NewestFirst,
      theme: null,
      tags: null });

    router.replace(
    {
      pathname: router.pathname,
      query: { lang: lang } },

    undefined,
    { shallow: true });

  };

  var updateFilters = function updateFilters(filter, value) {
    setFilters(_objectSpread(_objectSpread({}, filters), {}, (0,defineProperty/* default */.Z)({}, filter, value)));
    var query = _objectSpread(_objectSpread({},
    router.query), {}, (0,defineProperty/* default */.Z)({
      lang: lang },
    filter, value));

    if (!value) {
      var _query = query,_val = _query[filter],otherFilters = (0,objectWithoutProperties/* default */.Z)(_query, [filter].map(_toPropertyKey));
      query = otherFilters;
    }
    router.replace(
    {
      pathname: router.pathname,
      query: query },

    undefined,
    { shallow: true });

    (0,policies/* snackbarVar */.Ck)({
      isSnackBarOpen: true,
      snackBarMessage: esm/* i18n._ */.ag._( /*i18n*/{
        id: 'programs_2021.listings_page.filter_applied_toaster' }) });


  };

  var userResolved = currentUser === null || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
  var programsData = (data === null || data === void 0 ? void 0 : data.genericPrograms) || ssrData;

  var programs = programsData === null || programsData === void 0 ? void 0 : programsData.data;

  var content = null;
  if (!programs && (loading || !userResolved)) {
    content = [/*#__PURE__*/
    (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { justifyContent: "center", alignItems: "center", mt: 50, children: /*#__PURE__*/
      (0,jsx_runtime.jsx)(Spinner/* default */.Z, { size: 28, spinnerColor: "#242424" }) }, "loading")];


  } else if ((programs === null || programs === void 0 ? void 0 : programs.length) > 0) {var _programsData$data;
    content = [/*#__PURE__*/
    (0,jsx_runtime.jsx)(Cards, { children:
      programs === null || programs === void 0 ? void 0 : programs.map(function (program) {
        var programAccess = (0,helpers/* getUserProgramAccess */.VR)({
          user: currentUser,
          programSlug: program.slug,
          programCategory: program.category });


        return /*#__PURE__*/(
          (0,jsx_runtime.jsx)(ProgramListingCard/* default */.ZP, {

            program: program,
            accessStatus: programAccess === null || programAccess === void 0 ? void 0 : programAccess.accessStatus,
            programCategory: program.category }, program.slug));


      }) }, "cards")];



    if ((programsData === null || programsData === void 0 ? void 0 : programsData.totalCount) > (programsData === null || programsData === void 0 ? void 0 : (_programsData$data = programsData.data) === null || _programsData$data === void 0 ? void 0 : _programsData$data.length)) {
      var _loading =
      [core_networkStatus/* NetworkStatus.loading */.I.loading, core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore].includes(
      networkStatus) &&
      !(programsData !== null && programsData !== void 0 && programsData.data);

      content.push( /*#__PURE__*/
      (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { justifyContent: "center", mt: 40, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(LoadMore, {
          category: programCategory,
          appearance: "outline",
          onClick: loadMore,
          loading: _loading, children: /*#__PURE__*/

          (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "programs_2021.listings_page.load_more_btn" }) }) }, 1));



    }
  } else {
    content = [/*#__PURE__*/
    (0,jsx_runtime.jsx)(EmptyResults/* default */.Z, {

      icon: "ygb-icon-playlist-empty-ic",
      description: /*#__PURE__*/
      (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "programs_2021.listings_page.no_programs_found" }),

      action: /*#__PURE__*/
      (0,jsx_runtime.jsx)(buttons/* default */.ZP, { appearance: "link", onClick: clearFilters, children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(react_esm/* Trans */.cC, { id: "programs_2021.listings_page.clear_events_filters" }) }) }, "empty")];




  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsxs)("div", { children: [/*#__PURE__*/
      (0,jsx_runtime.jsx)(programs_listing_ProgramsFilters, {
        languages: filters.languages,
        instructor: filters.instructor,
        sortBy: filters.sortBy,
        theme: filters.theme,
        onInstructorChange: function onInstructorChange(instructor) {
          updateFilters('instructor', instructor);
        },
        onLanguageChange: function onLanguageChange(langs) {return updateFilters('languages', langs);},
        onSortChange: function onSortChange(sortBy) {return updateFilters('sortBy', sortBy);},
        onThemeChange: function onThemeChange(theme) {return updateFilters('theme', theme);},
        programCategory: programCategory }), /*#__PURE__*/

      (0,jsx_runtime.jsx)(Grid/* Container */.W2, { fullWidth: true, px: 20, children: /*#__PURE__*/
        (0,jsx_runtime.jsxs)(Grid/* Container */.W2, { flexDirection: "column", mb: 80, children: [/*#__PURE__*/
          (0,jsx_runtime.jsx)(Search/* default */.Z, {
            placeholder: /*i18n*/esm/* i18n._ */.ag._("programs_2021.listings_page.search_input_placeholder"),
            handleChange: function handleChange(value) {return updateFilters('search', value);},
            value: filters.search }),

          content] }) })] }));




};

/***/ }),

/***/ 38198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90116);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54444);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Language = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].button.withConfig({ displayName: "Languages__Language", componentId: "sc-2xcrxo-0" })(["flex-shrink:0;position:relative;width:30px;height:30px;border:1px solid ", ";border-radius:50%;padding:1px;margin-left:14px;background:none;box-sizing:border-box;cursor:pointer;outline:none;i{position:absolute;top:0;right:0;border:1px solid #129EDC;border-radius:50%;padding:2px;background-color:white;transform:translate(25%,-25%);}"],




function (_ref) {var selected = _ref.selected;return selected ? '#129EDC' : 'transparent';});




















var LanguageImage = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].img.withConfig({ displayName: "Languages__LanguageImage", componentId: "sc-2xcrxo-1" })(["width:100%;"]);



var available_languages = {
  se: '/static/icons/se.png',
  en: '/static/icons/en.png',
  no: '/static/icons/no.png',
  fi: '/static/icons/fi.png' };









var Languages = function Languages(_ref2)



{var onChange = _ref2.onChange,_ref2$languages = _ref2.languages,languages = _ref2$languages === void 0 ? null : _ref2$languages,_ref2$enabledLanguage = _ref2.enabledLanguages,enabledLanguages = _ref2$enabledLanguage === void 0 ? ['se', 'en'] : _ref2$enabledLanguage;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
  languages || Object.keys(available_languages)),selectedLanguages = _useState[0],setSelectedLanguages = _useState[1];


  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { children:
      Object.entries(available_languages).map(function (_ref3) {var _ref4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref3, 2),key = _ref4[0],path = _ref4[1];
        if (!enabledLanguages.includes(key)) {
          return null;
        }
        var selected = selectedLanguages.includes(key);
        return /*#__PURE__*/(
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Language, {

            selected: selected,
            onClick: function onClick() {
              var langs = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(selectedLanguages);
              if (selected) {
                // we always want one item selected
                if (selectedLanguages.length > 1) {
                  langs = langs.filter(function (lang) {return lang !== key;});
                }
              } else {
                langs.push(key);
              }

              setSelectedLanguages((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(langs));
              onChange((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(langs));
            }, children: [/*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(LanguageImage, { src: path }),
            selected ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { name: "ygb-icon-checkmark", fontSize: "8px", color: "#129EDC" }) :
            null] }, key));


      }) }));


};

/* harmony default export */ __webpack_exports__["Z"] = (Languages);

/***/ }),

/***/ 2949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ac": function() { return /* binding */ BodyText; },
/* harmony export */   "ck": function() { return /* binding */ Item; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90116);
/* harmony import */ var _components_Accordion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9451);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54444);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var List = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].ul.withConfig({ displayName: "SimpleAccordionList__List", componentId: "sc-tfidsa-0" })(["width:100%;display:flex;flex-direction:column;list-style:none;padding:0;"]);







var Item = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].li.withConfig({ displayName: "SimpleAccordionList__Item", componentId: "sc-tfidsa-1" })(["width:100%;border-bottom:2px solid #d8d8d8;padding:24px 0;"]);





var Title = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].p.withConfig({ displayName: "SimpleAccordionList__Title", componentId: "sc-tfidsa-2" })(["display:flex;justify-content:space-between;width:100%;color:#1c343e;font-weight:500;padding:10px 0px;margin:0;cursor:pointer;outline:none;"]);











var BodyText = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({ displayName: "SimpleAccordionList__BodyText", componentId: "sc-tfidsa-3" })(["padding:20px 0;margin:0;"]);










var SimpleAccordionList = function SimpleAccordionList(props) {
  var _props$className = props.className,className = _props$className === void 0 ? '' : _props$className,list = props.list,_props$multipleTabsOp = props.multipleTabsOpen,multipleTabsOpen = _props$multipleTabsOp === void 0 ? true : _props$multipleTabsOp;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),openItems = _useState[0],setOpenItems = _useState[1];

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(List, { className: className, children:
      list.map(function (item, i) {
        var isOpen = openItems.includes(i);
        return /*#__PURE__*/(
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Item, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Accordion__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
              head: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Title, { children: [
                item.title, /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                  name:
                  isOpen ? 'ygb-icon-chevron-up' : 'ygb-icon-chevron-down' })] }),




              body: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(BodyText, { children: item.body }),
              onOpenChange: function onOpenChange() {
                if (isOpen) {
                  setOpenItems(openItems.filter(function (index) {return index !== i;}));
                } else if (multipleTabsOpen) {
                  setOpenItems([].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(openItems), [i]));
                } else {
                  setOpenItems([i]);
                }
              },
              isOpen: isOpen }) }, i));



      }) }));


};

/* harmony default export */ __webpack_exports__["ZP"] = (SimpleAccordionList);

/***/ }),

/***/ 70021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31157);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97878);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var TrailerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({ displayName: "Trailer__TrailerWrapper", componentId: "sc-191tqp1-0" })(["flex:1;position:relative;height:auto;padding-top:calc(", "%);@media (min-width:", "px){min-width:350px;}"],



function () {return (100 / 1.777).toFixed(2);},

function (_ref) {var theme = _ref.theme;return theme.viewports.tablet;});




var TrailerVideo = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_index__WEBPACK_IMPORTED_MODULE_2__["default"]).withConfig({ displayName: "Trailer__TrailerVideo", componentId: "sc-191tqp1-1" })(["position:absolute;top:0;left:0;width:100%;height:100%;"]);

















var Trailer = function Trailer(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TrailerWrapper, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TrailerVideo, _objectSpread({}, props)) }));


};

/* harmony default export */ __webpack_exports__["Z"] = (Trailer);

/***/ }),

/***/ 15783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "buildProgramsFilters": function() { return /* binding */ buildProgramsFilters; }
/* harmony export */ });
/* harmony import */ var _lingui_core__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(94471);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(31157);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85169);
/* harmony import */ var _ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83689);
/* harmony import */ var _ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23502);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94007);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9128);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49613);
/* harmony import */ var _ecosystems_pricing_PricingSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27352);
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48354);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17516);
/* harmony import */ var _organisms_video_player_Trailer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70021);
/* harmony import */ var _ecosystems_programs_listing_FAQSection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70467);
/* harmony import */ var _components_MessageStripe__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35281);
/* harmony import */ var _ecosystems_programs_listing_ProgramsSearch__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72738);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47493);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);



















var HeroSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__["default"])(_ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({ displayName: "programs__HeroSection", componentId: "sc-14y10re-0" })(["width:100%;max-width:1280px;", "{padding-right:8%;margin:0 auto;z-index:1;", "{max-width:720px;}", "{display:flex;align-items:center;font-size:34px;color:#243240;line-height:1.2;margin-bottom:0px;span{font-size:11px;color:", ";font-weight:500;border-radius:3px;padding:5px;margin-left:12px;background-color:#129EDC;}}", "{font-size:20px;line-height:1.5;margin-top:24px;margin-bottom:24px;}", "{font-size:13px;margin-top:10px;}@media (max-width:", "px){", "{font-size:24px;}margin-top:20px;}@media (max-width:", "px){padding-right:0;}}", "{display:flex;align-items:center;border-radius:5px;overflow:hidden;}"],



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapper */ .OP,




_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapperInner */ .z5,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx,









function (_ref) {var theme = _ref.theme;return theme.colors.neutrals.white;},








_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK,






_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Disclaimer */ .em,




function (props) {return props.theme.viewports.tablet;},
_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx,





function (props) {return props.theme.viewports.mobile;},




_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .VideoWrapper */ .U1);







var WalkThroughSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC).withConfig({ displayName: "programs__WalkThroughSection", componentId: "sc-14y10re-1" })(["background-color:#F0F5FB;", "{", "{margin-bottom:0;}}"],


_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .TextWrapper */ .OP,
_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK);





var FaqButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__["default"])(_components_buttons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP).withConfig({ displayName: "programs__FaqButton", componentId: "sc-14y10re-2" })(["color:", ";border:1px solid ", ";;padding:11px 24px;margin-left:4px;background:white;:hover{background:white;}"],
function (_ref2) {var theme = _ref2.theme;return theme.colors.secondary['gray-5'];},
function (_ref3) {var theme = _ref3.theme;return theme.colors.secondary['gray-5'];});









var heroVideo = {
  id: '52f0d8b2-1f91-48a2-aae5-9f94ecaa3ece',
  identifier: 'k2g3',
  content: { title: 'program listing page trailer' },
  hls:
  'https://yogobe.23video.com/64968558/71570629/7fe60ee307a76da35b6893f291f21bb2/video_hls/playlist.m3u8',
  thumbnailUrl:
  'https://yogobe.23video.com/64968558/71570629/e0cd1296fce79b49f16c7f11689368e0//programoverview1920x1080onsitemp4-11-thumbnail.jpglarge/embed/thumbnail.jpg',
  player: {
    hasAccess: true,
    assets: [
    {
      src:
      'https://yogobe.23video.com/64968558/71570629/7fe60ee307a76da35b6893f291f21bb2/video_mobile_high/programoverview1920x1080onsitemp4-11-video.mp4',
      resolution: 180 },

    {
      src:
      'https://yogobe.23video.com/64968558/71570629/7fe60ee307a76da35b6893f291f21bb2/video_medium/programoverview1920x1080onsitemp4-11-video.mp4',
      resolution: 360 },

    {
      src:
      'https://yogobe.23video.com/64968558/71570629/7fe60ee307a76da35b6893f291f21bb2/video_hd/programoverview1920x1080onsitemp4-11-video.mp4',
      resolution: 720 },

    {
      src:
      'https://yogobe.23video.com/64968558/71570629/7fe60ee307a76da35b6893f291f21bb2/video_1080p/programoverview1920x1080onsitemp4-11-video.mp4',
      resolution: 1080 }] } };





var programWalkthrough = {
  id: '4eb82b44-5947-4f35-9b86-6637f3ee1377',
  identifier: '8we5',
  hls:
  'https://yogobe.23video.com/64968561/71881363/6b726d1b7a8d87ab869a60b7964486cb/video_hls/playlist.m3u8',
  thumbnailUrl:
  'https://yogobe.23video.com/64968561/71881363/4d159ec4b76d0c07c042aa40bdcae7a7//1920x1080program-tutorial1mp4-8-thumbnail.jpglarge/embed/thumbnail.jpg',
  player: {
    hasAccess: true,
    assets: [
    {
      src:
      'https://yogobe.23video.com/64968561/71881363/6b726d1b7a8d87ab869a60b7964486cb/video_mobile_high/1920x1080program-tutorial1mp4-8-video.mp4',
      resolution: 180 },

    {
      src:
      'https://yogobe.23video.com/64968561/71881363/6b726d1b7a8d87ab869a60b7964486cb/video_medium/1920x1080program-tutorial1mp4-8-video.mp4',
      resolution: 360 },

    {
      src:
      'https://yogobe.23video.com/64968561/71881363/6b726d1b7a8d87ab869a60b7964486cb/video_hd/1920x1080program-tutorial1mp4-8-video.mp4',
      resolution: 720 },

    {
      src: 'https://yogobe.23video.com',
      resolution: 1080 }] } };var __N_SSP = true;





var buildProgramsFilters = function buildProgramsFilters(query) {
  var languages = query !== null && query !== void 0 && query.languages ?
  [query.languages].flat() :
  ['en', 'se', 'no', 'fi'];
  return {
    search: (query === null || query === void 0 ? void 0 : query.search) || '',
    languages: languages,
    instructor: (query === null || query === void 0 ? void 0 : query.instructor) || null,
    theme: (query === null || query === void 0 ? void 0 : query.theme) || null,
    category: null,
    sortBy:
    (query === null || query === void 0 ? void 0 : query.sortBy) ||
    _gql_generated__WEBPACK_IMPORTED_MODULE_7__/* .GenericProgramSortAttribute.NewestFirst */ .N$9.NewestFirst,
    tags: null };

};

var ProgramsListings = function ProgramsListings(_ref4) {var pageProps = _ref4.pageProps;
  var lang = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z);
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_13__/* .UserContext */ .S),currentUser = _useContext[0];

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        title: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_16__/* .i18n._ */ .ag._("programs_2021.listing_page.meta.title"),
        description: /*i18n*/_lingui_core__WEBPACK_IMPORTED_MODULE_16__/* .i18n._ */ .ag._("programs_2021.listing_page.meta.description"),
        thumbnailUrl: "/static/programs_meta_image.jpg" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_MessageStripe__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, { bg: "#e2d2af", color: "#242424", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_17__/* .Trans */ .cC, {
          id: "programs_2021.listing_page.legacy_programs_banner",
          components: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_MessageStripe__WEBPACK_IMPORTED_MODULE_11__/* .Link_ */ .TQ, { href: "/".concat(lang, "/program-old") }, "0")] }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { justifyContent: "center", px: 20, py: [0, 20, 40], children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(HeroSection, {
          title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_17__/* .Trans */ .cC, { id: "programs_2021.listings_page.hero_title" }),
          subtitle: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_17__/* .Trans */ .cC, { id: "programs_2021.listings_page.subtitle" }),
          actions: [
          {
            name: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_17__/* .Trans */ .cC, { id: "programs_2021.listings_page.explore_programs_btn" }),

            theme: 'stone',
            href: '#explore-programs' }, /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(FaqButton, { href: "#faq", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_17__/* .Trans */ .cC, { id: "programs_2021.listings_page.faq_btn" }) }, "faq")],


          video: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_organisms_video_player_Trailer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {

            video: heroVideo,
            thumbnailImage: heroVideo.thumbnailUrl,
            isLimited: false,
            autoPlay: false,
            videoSources: heroVideo.player.assets,
            elementID: heroVideo.id }),



          disclaimer:
          !(currentUser !== null && currentUser !== void 0 && currentUser.isPremium) ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_17__/* .Trans */ .cC, { id: "programs_2021.listing_page.hero.no_premium_disclaimer" }) : /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_17__/* .Trans */ .cC, { id: "programs_2021.listing_page.hero.premium_disclaimer" }),


          reverseColumns: true }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsxs)("div", { id: "explore-programs", children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_ecosystems_programs_listing_ProgramsSearch__WEBPACK_IMPORTED_MODULE_12__/* .ProgramsSearch */ .Y, {
          initialFilters: pageProps.initialFilters,
          ssrData: pageProps.ssrPrograms,
          programCategory: _gql_generated__WEBPACK_IMPORTED_MODULE_7__/* .ProgramCategory.Programs */ .l92.Programs }),

        ['se', 'no'].includes(lang) ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(WalkThroughSection, {
          justifyContent: "center",
          px: 20,
          py: [0, 20, 40],
          mb: 20, children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(HeroSection, {
            title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_17__/* .Trans */ .cC, { id: "programs_listing.walkthrough_section.title" }),
            subtitle: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_17__/* .Trans */ .cC, { id: "programs_listing.walkthrough_section.subtitle" }),

            video: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_organisms_video_player_Trailer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {

              video: programWalkthrough,
              thumbnailImage: programWalkthrough.thumbnailUrl,
              isLimited: false,
              autoPlay: false,
              videoSources: programWalkthrough.player.assets,
              elementID: programWalkthrough.id }) }) }) :





        null, /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_ecosystems_programs_listing_FAQSection__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)("div", { children:
          currentUser !== null && currentUser !== void 0 && currentUser.isNoneTrialPremium ? null : /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(_ecosystems_pricing_PricingSection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, { id: "subscription-offers" }) })] })] }));





};




























/* harmony default export */ __webpack_exports__["default"] = (ProgramsListings);

/***/ })

}]);